import { createTheme } from '@mui/material/styles';
import { blueGrey, red } from '@mui/material/colors';

export const theme = createTheme({
  palette: {
    primary: red,
  },
});
